import {
  CPSConfig,
  CPSConfigFunctionnality,
  HistoryChartModeEnum,
  HistoryGraphModeEnum,
  HistoryGraphYModeEnum,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P0003605FunctionFinish } from './P0003605/Installation/P0003605InstallationFinish';
import { P00039DataRxTxIndex } from './P00039Sync';
import { P0003605FunctionReset } from './P0003605/Installation/P0003605InstallationReset';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P0003605InjectionChloreMiseEnOeuvreInit } from './P0003605/InjectionChlore/miseenoeuvre/P0003605InjectionChloreMiseEnOeuvreInit';
import { P0003605InjectionChloreMiseEnOeuvreDesinfectionComponent } from './P0003605/InjectionChlore/miseenoeuvre/p0003605-injection-chlore-mise-en-oeuvre-desinfection/p0003605-injection-chlore-mise-en-oeuvre-desinfection.component';
import { P0003605InjectionChloreMiseEnOeuvreSecuriteComponent } from './P0003605/InjectionChlore/miseenoeuvre/p0003605-injection-chlore-mise-en-oeuvre-securite/p0003605-injection-chlore-mise-en-oeuvre-securite.component';
import { P0003605InjectionChloreMiseEnOeuvreHivernageComponent } from './P0003605/InjectionChlore/miseenoeuvre/p0003605-injection-chlore-mise-en-oeuvre-hivernage/p0003605-injection-chlore-mise-en-oeuvre-hivernage.component';
import { P0003605InjectionChloreStatutComponent } from './P0003605/InjectionChlore/cps/p0003605-injection-chlore-statut/p0003605-injection-chlore-statut.component';
import { P0003605InjectionChloreParametersComponent } from './P0003605/InjectionChlore/cps/p0003605-injection-chlore-parameters/p0003605-injection-chlore-parameters.component';
import { P0003605InjectionChloreControleComponent } from './P0003605/InjectionChlore/cps/p0003605-injection-chlore-controle/p0003605-injection-chlore-controle.component';
import { P0003605CardInjectionChloreControleComponent } from './P0003605/InjectionChlore/cards/p0003605-card-injection-chlore-controle/p0003605-card-injection-chlore-controle.component';
import { P0003605CardInjectionChloreStatutComponent } from './P0003605/InjectionChlore/cards/p0003605-card-injection-chlore-statut/p0003605-card-injection-chlore-statut.component';
import { P0003605InstallationDosageComponent } from './P0003605/Installation/p0003605-installation-dosage/p0003605-installation-dosage.component';
import { P0003605InstallationDetecteurFinBidonComponent } from './P0003605/Installation/p0003605-installation-detecteur-fin-bidon/p0003605-installation-detecteur-fin-bidon.component';
import { P0003605Alarm } from './P0003605/Alarm/P0003605Alarm';

export class P0003605Data {
  icCModeFonctionnement: number = 0;

  icCCommandeAmorcageCloud: number = 0;

  icCCommandeAmorcageBle: number = 0;

  icCCommandeAmorcageIHM: number = 0;

  icCAckUtilisateur: number = 0;

  icCResetCompteur: number = 0;

  icCConfirmationOTA: number = 0;

  icCResetUsine: number = 0;

  icPDureeEntreDeuxInjections: number = 0;

  icPDureeInjection: number = 0;

  icPConsigneRegulationRx: number = 0;

  icPHysteresisRegulationRx: number = 0;

  icPDureeLimiteSurdosage: number = 0;

  icPDureeMaximumQuotidienne: number = 0;

  icPActivationSecuriteDesinfection: number = 0;

  icIConfigurationProduit: number = 0;

  icIActivationFonctionAutoMaintien: number = 0;

  icIActivationProtectionSurdosage: number = 0;

  icIDetecteurFinBidonInstalle: number = 0;

  icISensContactFinBidon: number = 0;

  icISondeRxReference: number = 0;

  icISourceReferenceDebit: number = 0;

  icISourceReferenceFonctionVolet: number = 0;

  icSEtatBouton: number = 0;

  icSAlarme: number = 0;

  icSEtatPompe: number = 0;

  icSCommandeInjection: number = 0;

  icSCommandeAmorcage: number = 0;

  icSMesureRxReferenceDisponible: number = 0;

  icSCommandeRegulation: number = 0;

  icSMiseEnRouteFiltration: number = 0;

  icSArretInjection: number = 0;

  icSVigilenceChlore: number = 0;

  icSEtatContactFinBidon: number = 0;

  icSFinBidon: number = 0;

  icSCommandeInjectionHivernage: number = 0;

  icSSecuriteDesinfection: number = 0;

  icSEtatVolet: number = 0;

  icSDisponibiliteVolet: number = 0;

  icSCompteurBouton: number = 0;

  icSNombreCommutationRelais: number = 0;

  icSDureeEntreDeuxInjections: number = 0;

  icSDureeInjection: number = 0;

  icSMesureRxReference: number = 0;

  icSDetectionDebitReference: number = 0;

  icSCompteurSurdosageEnSecondes: number = 0;

  icSNombreTotalProtectionSurdosage: number = 0;

  icSDureeDebitMaintenu: number = 0;

  icSDureeInjectionEffectue: number = 0;

  icSCompteurResetUsine: number = 0;

  icSCompteurTempsInjection: number = 0;

  icSModeRegulation: number = 0;

  icSSecuriteInjectionCLPH: number = 0;

  icSCompteurResetCompteur: number = 0;
}

export class P0003605 extends IProduct {
  override deviceTableIndex: number = 8;

  override modelIdentifier?: string = 'P00036-05';

  override dataIdentifier?: string = 'P0003605';

  override manufacturerName?: string = 'ACWA';

  data: P0003605Data = new P0003605Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P0003605/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P0003605/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P0003605/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P0003605;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P0003605?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P0003605.tuto.installation.help.title',
      helpSlides: [
        'P0003605.tuto.installation.help.1',
        'P0003605.tuto.installation.help.2',
        'P0003605.tuto.installation.help.3',
        'P0003605.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003605/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0003605/installation-1_dark.png',
          },
          text: 'P0003605.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003605/installation-2.png',
            dark: '/assets/ecosystem/images/products/P0003605/installation-2_dark.png',
          },
          text: 'P0003605.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003605/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0003605/installation-1_dark.png',
          },
          text: 'P0003605.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P0003605/update-2.png',
            dark: '/assets/ecosystem/images/products/P0003605/update-2_dark.png',
          },
          text: 'P0003605.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          {
            component: P0003605InstallationDosageComponent,
            condition: () => {
              return true;
            },
          },
          {
            component: P0003605InstallationDetecteurFinBidonComponent,
            condition: () => {
              return true;
            },
          },
        ],
        finish: P0003605FunctionFinish,
        reset: P0003605FunctionReset,
      },
      controlCards: [
        { component: P0003605CardInjectionChloreControleComponent, weight: 18 },
      ],

      statusCards: [
        { component: P0003605CardInjectionChloreStatutComponent, weight: 18 },
      ],

      alarms: {
        weight: 22,
        component: P0003605Alarm,
      },

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.DISINFECTION];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality | EventProductFunctionnalityEnum,
  ): CPSConfigFunctionnality | null {
    if (
      functionnality == IProductFunctionnality.INJECTION_CHLORE ||
      functionnality == EventProductFunctionnalityEnum.DISINFECTION
    ) {
      return {
        miseEnOeuvre: {
          init: P0003605InjectionChloreMiseEnOeuvreInit,
          pages: [
            {
              component:
                P0003605InjectionChloreMiseEnOeuvreDesinfectionComponent,
              condition: () => {
                return true;
              },
            },
            {
              component: P0003605InjectionChloreMiseEnOeuvreSecuriteComponent,
              condition: () => {
                return true;
              },
            },
            {
              component: P0003605InjectionChloreMiseEnOeuvreHivernageComponent,
              condition: () => {
                return true;
              },
            },
          ],
        },
        controle: {
          enabledUser: true,
          enabledSupport: true,

          component: P0003605InjectionChloreControleComponent,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,

          reglage: {
            enabledUser: true,
            enabledSupport: true,
            component: P0003605InjectionChloreParametersComponent,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          component: P0003605InjectionChloreStatutComponent,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            graphiques: [
              {
                title: 'P0003605.historique.commandeInjection',
                mode: HistoryGraphModeEnum.DATA,
                property: 'icSCompteurTempsInjection',
                aggregate: 'delta',
                yMode: HistoryGraphYModeEnum.SECONDE,
                yModeOptions: {
                  min: 0,
                  max: 18 * 60,
                  minMensuel: 0,
                  maxMensuel: 7.5 * 60 * 60,
                  step: 6 * 60,
                  stepMensuel: 30 * 60,
                },
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
              },
              {
                title: 'P0003605.historique.commandeInjectionLitre',
                mode: HistoryGraphModeEnum.DATA,
                property: 'icSCompteurInjectionLitre',
                aggregate: 'delta',
                yMode: HistoryGraphYModeEnum.LITRE,
                yModeOptions: {
                  min: 0,
                  max: 0.5,
                  minMensuel: 0,
                  maxMensuel: 2,
                  step: 0.1,
                  stepMensuel: 0.5,
                },
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
              },
              {
                title: 'P0003605.historique.mesureRX',
                mode: HistoryGraphModeEnum.DATA,
                property: 'icSMesureRxReference',
                aggregate: 'avg',
                yMode: HistoryGraphYModeEnum.MVOLT,
                yModeOptions: { min: 0, max: 1000 },
                chartMode: HistoryChartModeEnum.LINEAR,
              },
            ],
          },
        },
      };
    }

    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.InjectionChlore_Controle,
      propertyName: 'icCConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 15;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).icIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.csv'
    );
  }
}
